import React, { useState } from 'react';
import { useEffect } from 'react';
import { Box, Paper, Stepper, Step, StepLabel, Button, Typography, Snackbar, Alert, useMediaQuery, useTheme } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import HeaderEntreprise from '../../header/headerEntreprise';
import { useNavigate } from 'react-router-dom';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import './Addmission.css';
import Chatbox from '../../commun/ChatBox';
import Footer from '../../commun/Footer';

const steps = ['Informations mission', 'Profil recherché', 'Contact'];

export default function Addmission() {
    const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [usersList, setUsersList] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nomMission: '',
    lieuxTravail: '',
    remuneration: '',
    dateDebut: null,
    urgenceMission: '',
    modeTravail: '',
    contexteMission: '',
    document: null,
    typeContrat:'',
    competences: [],
    criteres: [],
    softSkills: [],
    langues: [],
    experience: '',
    formation: '',
    disponibilite: null,
    secteur: '',
    nom: '',
    email: '',
    telephone: '',
    role: '',
    dateLimite: null,
    recruteursMax: '',
    placesDispo: '',
    garantie: '',
    devise: 'EUR',
    infoComplementaires: '',
  });


  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const entrepriseId = localStorage.getItem('userId');
        const res = await fetch(`${API_BASE}/api/entreprise/profil/${entrepriseId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const entreprise = await res.json();

        const users = [
          {
            id: entreprise.utilisateur?._id,
            nom: `${entreprise.utilisateur?.firstName || ''} ${entreprise.utilisateur?.lastName || ''}`.trim(),
            email: entreprise.utilisateur?.email,
            telephone: entreprise.utilisateur?.phone,
          },
          ...(entreprise.utilisateursAdditionnels || []).map(u => ({
            id: u._id,
            nom: `${u.firstName || ''} ${u.lastName || ''}`.trim(),
            email: u.email,
            telephone: u.phone,
          }))
        ].filter(u => u.email); // filtre ceux sans mail

        setUsersList(users);
      } catch (err) {
        console.error('Erreur chargement users:', err);
      }
    };
    fetchUsers();
  }, [API_BASE]);

  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const validateStep = (step) => {
    const newErrors = {};
  
    if (step === 0) {
      ['nomMission', 'lieuxTravail', 'remuneration', 'contexteMission'].forEach(k => {
        if (!formData[k]) newErrors[k] = 'Champ requis';
      });
    }
  
    if (step === 1) {
      ['typeContrat'].forEach(k => {
        if (!formData[k]) newErrors[k] = 'Champ requis';
      });
      ['competences'].forEach(field => {
        if (!Array.isArray(formData[field]) || formData[field].length === 0) {
          newErrors[field] = 'Veuillez valider vos saisies en appuyant sur Entrée.';
        }
      });
  
      if (!formData.disponibilite) {
        newErrors['disponibilite'] = 'Champ requis';
      }
    }
  
    if (step === 2) {
      ['nom', 'email', 'telephone', 'role', 'dateLimite'].forEach(k => {
        if (!formData[k]) newErrors[k] = 'Champ requis';
      });
    }
  
    setErrors(newErrors);
  
    if (Object.keys(newErrors).length > 0) {
      const specificError = Object.values(newErrors).find(e => e.includes('valider vos saisies'));
      setSnackbar({
        open: true,
        message: specificError || 'Merci de remplir tous les champs obligatoires.',
        severity: 'error',
      });
      return false;
    }
  
    return true;
  };
  
  const handleNext = () => {
    if (validateStep(activeStep)) {
      setActiveStep((s) => s + 1);
    }
  };  
  
  const handleBack = () => setActiveStep(s => s - 1);

  const readFileAsDataURL = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = (err) => {
        reject(err);
      };
      reader.readAsDataURL(file);
    });
  };
  
  const handleFinish = async () => {
    if (!validateStep(2)) {
      setSnackbar({
        open: true,
        message: 'Merci de remplir tous les champs obligatoires.',
        severity: 'error',
      });
      return;
    }
  
    const token = localStorage.getItem('authToken');
    const entrepriseId = localStorage.getItem('userId');
  
    try {
  
      let documentPayload = null;
  
      if (formData.document instanceof File) {
        const base64 = await readFileAsDataURL(formData.document);
        documentPayload = {
          name: formData.document.name,
          data: base64,
        };
      } else if (formData.document?.data && formData.document?.name) {
        documentPayload = formData.document;
      } 
  
      const payload = {
        ...formData,
        createdBy: entrepriseId,
        garantie: formData.garantie ? `${formData.garantie} mois` : '',
        document: documentPayload,
        langues: Array.isArray(formData.langues)
          ? formData.langues.filter(
              (lang) => typeof lang === 'object' && lang.langue && lang.niveau
            )
          : [],
      };
  
  
      const res = await fetch(`${API_BASE}/api/missions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
  
      if (!res.ok) {
        const err = await res.json();
        console.error('❌ Server error response:', err);
        throw err;
      }
  
      setSnackbar({ open: true, message: 'Mission créée avec succès !', severity: 'success' });
      setTimeout(() => {
        navigate('/Entreprise/Missions');
      }, 1000);
    } catch (err) {
      console.error('❌ handleFinish error:', err);
      setSnackbar({ open: true, message: err.message || 'Erreur serveur.', severity: 'error' });
    }
  };
  
    

  const handleChange = (field, value) => {
    setFormData(f => ({ ...f, [field]: value }));
    setErrors(e => ({ ...e, [field]: undefined }));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box className="addmission-wrapper">
        <HeaderEntreprise entrepriseName={localStorage.getItem('entrepriseName')} />
        <Paper elevation={0} className="addmission-stepper-wrapper">
          <Stepper
            activeStep={activeStep}
            alternativeLabel={!isMobile}
            orientation={isMobile ? 'vertical' : 'horizontal'}
          >
            {steps.map(label => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Paper>

        <Box className="addmission-content">
          <Box component={Paper} elevation={1} className="addmission-main-form">
          {activeStep === 0 && <StepOne data={formData} errors={errors} onChange={handleChange} />}
          {activeStep === 1 && <StepTwo data={formData} errors={errors} onChange={handleChange} />}
          {activeStep === 2 && (<StepThree data={formData} errors={errors} onChange={handleChange} users={usersList}/>)}

            <Box className="addmission-navigation-buttons">
              <Button disabled={activeStep === 0} onClick={handleBack}>← Précédent</Button>
              {activeStep < steps.length - 1 ? (
                <Button variant="contained" onClick={handleNext}>Suivant →</Button>
              ) : (
                <Button variant="contained" onClick={handleFinish}>Valider</Button>
              )}
            </Box>
          </Box>

          <Box component={Paper} elevation={1} className="addmission-sidebar">
            <Typography variant="h6" gutterBottom>Informations</Typography>
            <Typography variant="body2" paragraph>
              L'intitulé du poste apparaîtra en haut de votre annonce.
            </Typography>
            <Typography variant="h6" gutterBottom>Contexte de la mission</Typography>
            <Typography variant="body2">
              Une description détaillée des missions permet aux recruteurs de mieux cerner vos besoins.
            </Typography>
                        <Typography variant="h6" gutterBottom>Important</Typography>
            <Typography variant="body2">
              Toutes les informations saisies ici seront prises en compte pour le matching automatisé par l’IA. Veillez à remplir chaque champ avec précision afin d’optimiser la pertinence des profils proposés.
            </Typography>
          </Box>
        </Box>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar(s => ({ ...s, open: false }))}
        >
          <Alert
            onClose={() => setSnackbar(s => ({ ...s, open: false }))}
            severity={snackbar.severity}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
        <Footer />
        <Chatbox userRole="entreprise" />
      </Box>
    </LocalizationProvider>
  );
}
